import { render, staticRenderFns } from "./syzn.vue?vue&type=template&id=9f2237e0&scoped=true&"
import script from "./syzn.vue?vue&type=script&lang=js&"
export * from "./syzn.vue?vue&type=script&lang=js&"
import style0 from "./syzn.vue?vue&type=style&index=0&id=9f2237e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2237e0",
  null
  
)

export default component.exports